import numerify from 'numerify'

const RMB = {
  base: 10000,
  suffixes: ['', '万', '亿', '万亿'],
}

const rmb = {
  regexp: /[0\s]RMB/,
  format: function format (value, formatType, roundingFunction, numerify) {
    let output = 0
    let suffix = ' '
    formatType = formatType.replace(/\s?RMB/, '')
    for (let power = 0; power <= RMB.suffixes.length; power++) {
      const min = Math.pow(RMB.base, power)
      const max = Math.pow(RMB.base, power + 1)

      if (value === null || value === 0 || (value >= min && value < max)) {
        suffix += RMB.suffixes[power]

        if (min > 0) value = value / min

        break
      }
    }

    output = numerify._numberToFormat(value, formatType, roundingFunction)
    return output + suffix
  },
}

numerify.setOptions({ scalePercentBy100: false })
numerify.register('RMB', rmb)
export default numerify
